export default __webpack_public_path__ + "graphics/body.f47a2e89.jpg";